import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Navbar from "../../../Components/Common/navbar";
import { API, BACKEND_HOST } from "../../../api";
import { useAuthContext } from "../../../Components/AuthContext";
import MobileViewContainer from "../../../Components/MobileViewContainer";
import PromotionGiftLayout from "../../Promotion/components/PromotionGiftLayout";
import { mapGiftTicketItem } from "../components/giftPageMappers";

const GiftTicketPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { isUserLogin } = useAuthContext();

  const [ticketItem, setTicketItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const fetchItem = () => {
    setIsLoading(true);
    setError(null);

    API.get(`${BACKEND_HOST}/ticket/share-gift/${id}/`)
      .then((response) => response.data)
      .then((data) => {
        setTicketItem(data);
      })
      .catch((e) => {
        console.log(e);
        setError(e);
        setTicketItem(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!isUserLogin) {
      setTicketItem(null);
      setError(null);
      setIsLoading(false);
      return;
    }

    fetchItem();
  }, [isUserLogin, id]);

  const mappedItem = mapGiftTicketItem(ticketItem);

  const handlePrimaryAction = () => {
    if (!isUserLogin) {
      navigate(`/login?path=${location.pathname}`);
      return;
    }

    if (!ticketItem || mappedItem.isReceived || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    API.put(`/ticket/receive-ticket-gift/${id}/`, {})
      .then(() => {
        toast.error("선물을 받았습니다.");
      })
      .catch((e) => {
        console.log(e);
        toast.error("선물을 받을 수 없습니다.");
      })
      .finally(() => {
        setIsSubmitting(false);
        if (isUserLogin) {
          fetchItem();
        }
      });
  };

  return (
    <MobileViewContainer>
      <Navbar />
      <PromotionGiftLayout
        {...mappedItem}
        isLoggedIn={isUserLogin}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
        isReceived={mappedItem.isReceived}
        onPrimaryAction={handlePrimaryAction}
        error={error}
        loggedOutMessage="로그인 하여 선물을 확인하세요."
        hideSiteSectionWhenEmpty={true}
      />
    </MobileViewContainer>
  );
};

export default GiftTicketPage;
